import React from "react";
import { Row, Col, Button, Modal, ProgressBar } from "react-bootstrap";
import moment from "moment";
import "bootstrap-daterangepicker/daterangepicker.css";
import {
  DateRange,
  AttachFile,
  Close,
  DeleteOutline,
  Schedule,
} from "@material-ui/icons";

import { Formik, Field, Form, ErrorMessage } from "formik";
import "bootstrap-daterangepicker/daterangepicker.css";
import { connect } from "react-redux";
import { Mention, MentionsInput } from "react-mentions";
import defaultStyle from "../../MasterTemplate/defaultStyle";
import {
  getVarriableRefAction,
  getSpecialTaskAction,
} from "../../../actions/TransactionActions";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import Dropzone from "react-dropzone";
import { ContentState, convertToRaw, EditorState } from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import $ from "jquery";
import "bootstrap-daterangepicker/daterangepicker.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ReactSelect from "react-select";
import {
  addDocAction,
  updateDocAction,
  uploadDocumentAction,
  documentNotificationAction,
  listDocAction,
} from "./../../../actions/DocActions";
import { createTaskAction } from "./../../../actions/TransactionActions";
import * as Yup from "yup";
import SetDependency from "./set-dependency";
import {
  getMinutes,
  getTimeFormat,
  toastMessage,
  convertTZ,
  getContingencyData,
} from "./../../Common/Common";
import * as code from "./../../../config/Constants";
import * as message from "./../../../config/CommonMessages";

var _ = require("lodash");
class TaskAdd extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false,
      startDate: moment(),
      closeDate: moment().subtract(-29, "days"),
      taskType: "Communication",
      showText: true,
      taskData: {
        transactionId: "",
        campaign: "",
        title: "",
        day: 0,
        contingency: "",
        assignee: "",
        status: "SCHEDULED",
        eventType: "COMMUNICATION",
        communicationSubject: [""],
        communicationTo: [""],
        communicationToUserId: [""],
        description: [""],
        communicationType: "EMAIL",
        eventStartDate: new Date(
          moment()
            .startOf("day")
            .add(12, "hours")
        ),
        eventEndDate: new Date(
          moment()
            .startOf("day")
            .add(13, "hours")
        ),
        time: 720,
        document: true,
        isReminder: false,
        reminderDate:
          new Date() > new Date(this.props.transactionData.startDate || "")
            ? new Date()
            : new Date(this.props.transactionData.startDate || ""),
        reminderTime: 480,
        specialTask: [],
        duration: 60,
      },
      editEmailTo: false,
      editcommunicationDesctription: false,
      emailRefVar: [],
      variablesRefs: [],
      textRefVar: [],
      AllRefVarForMapping: [],
      AllRefVar: [],
      emailTextValForEditor: EditorState.createEmpty(),
      actualEmailTextValForEditor: EditorState.createEmpty(),
      detailsValForEditor: EditorState.createEmpty(),
      actualValues: {},
      showLoader: false,
      contingencies: [],
      DependencyModal: false,
      acceptedFiles: [],
      assigneeOptions: [
        {
          label: "select",
          value: "",
        },
      ],
      specialTask: [],
      specialtaskforinterativeEventType: [],
      specialtaskforCommunicativeEventType: [],
      isDateUpdated: false,
    };
  }

  // show task detail
  editTask = (i) => {
    if (i == 0) {
      this.setState({ editTask: "open" });
    } else {
      this.props.onUpdate("");
    }
  };

  DependencyModal() {
    this.setState({ DependencyModal: !this.state.DependencyModal });
  }

  showTaskType(e) {
    if (e + "".toUpperCase() == "COMMUNICATION") {
      this.setState({ taskType: true });
      this.setState({
        specialTask: this.state.specialtaskforCommunicativeEventType,
      });
    } else {
      this.setState({ taskType: false });
      this.setState({
        specialTask: this.state.specialtaskforinterativeEventType,
      });
    }
  }

  /**
   * clear communication to, subject and description
   * @param {*} setFieldValue
   * @param {*} setErrors
   */
  clearCommunication(setFieldValue, setErrors) {
    setFieldValue("communicationTo", [""]);
    setFieldValue("communicationSubject", [""]);
    setFieldValue("description", [""]);
    var taskData = this.state.taskData;
    taskData.communicationTo = [""];
    taskData.communicationSubject = [""];
    taskData.description = [""];
    this.setState({ actualValues: {} });
    this.setState(
      { taskData },
      () => {
        this.getEditorContent(this.state.taskData);
      },
      () => {
        setErrors({});
      }
    );
    setErrors({});
  }

  // Communication Type condition
  showText(e) {
    if ((e + "").toUpperCase() == "EMAIL") {
      this.setState({ showText: true });
    } else {
      this.setState({ showText: false });
    }
  }

  bindSubmitForm = (submitForm) => {
    this.submitMyForm = submitForm;
  };

  /**
   * @desc get all variables by api and devide it to email and text varieable
   * @param {*} con
   */
  getVariables(con) {
    this.props
      .getVarriableRefAction(this.props.transactionData._id)
      .then((res) => {
        var emailRefVar = [];
        var textRefVar = [];
        var AllRefVar = [];
        var AllRefVarForMapping = [];
        var AllRefVarForEditor = [];
        var variablesRefs = res || [];

        for (var i = 0, len = variablesRefs.length; i < len; i++) {
          if (variablesRefs[i].account !== "user") {
            AllRefVar.push({
              id: variablesRefs[i].name,
              display: variablesRefs[i].name,
            });

            AllRefVarForMapping.push(variablesRefs[i].name);
            //setting data as array for editore mention input
            AllRefVarForEditor.push({
              text: variablesRefs[i].name,
              value: variablesRefs[i].name.replace("@", ""),
              url: "",
            });
          }
          if (variablesRefs[i].communicationtype === "EMAIL") {
            emailRefVar.push({
              id: variablesRefs[i].name,
              display: variablesRefs[i].name,
            });
          }
          if (variablesRefs[i].communicationtype === "TEXT") {
            textRefVar.push({
              id: variablesRefs[i].name,
              display: variablesRefs[i].name,
            });
          }
        }
        this.setState(
          {
            variablesRefs,
            emailRefVar: emailRefVar,
            textRefVar: textRefVar,
            AllRefVar: AllRefVar,
            AllRefVarForEditor: AllRefVarForEditor,
            AllRefVarForMapping: AllRefVarForMapping,
          },
          () => {
            let assigneeOptions = [];
            //for assignee options - based on contigency
            this.state.variablesRefs.forEach((v) => {
              if (con !== undefined && con !== "") {
                if (
                  (v.contingency === "all" || v.contingency === con) &&
                  v.account === "user"
                ) {
                  assigneeOptions.push({ label: v.name, value: v.name });
                }
              } else {
                if (v.account === "user") {
                  assigneeOptions.push({ label: v.name, value: v.name });
                }
              }
            });
            this.setState({
              assigneeOptions,
            });
          }
        );
      });
  }

  /**
   * @desc get editor content for task description
   * @param {*} values
   */
  getEditorContent(values) {
    var emailTextValForEditor = EditorState.createEmpty();

    var detailsValForEditor = EditorState.createEmpty();
    let contentBlock = htmlToDraft(
      values.description &&
        values.description.length > 0 &&
        values.description[0]
    );
    if (contentBlock) {
      const contentState = ContentState.createFromBlockArray(
        contentBlock.contentBlocks
      );
      emailTextValForEditor = EditorState.createWithContent(contentState);
    }

    if ((values.type + "").toUpperCase() === "INTERACTIVE") {
      let contentBlock = htmlToDraft(
        values.description &&
          values.description.length > 0 &&
          values.description[0]
      );
      if (contentBlock) {
        const contentState = ContentState.createFromBlockArray(
          contentBlock.contentBlocks
        );
        detailsValForEditor = EditorState.createWithContent(contentState);
      }
    }
    this.setState({ emailTextValForEditor, detailsValForEditor });
  }

  componentWillMount() {
    var taskData = this.state.taskData;
    var dateStr = moment(taskData.eventEndDate).format("YYYY-MM-DD");
    var timeStr = getTimeFormat(780);

    var rdateStr = moment(taskData.reminderDate).format("YYYY-MM-DD");
    var rtimeStr = getTimeFormat(taskData.reminderTime);

    // taskData.eventEndDate = new Date(dateStr + " " + timeStr);
    // taskData.reminderDate = new Date(rdateStr + " " + rtimeStr);

    //On mac add task popup not working so added below code
    taskData.eventEndDate = new Date(`${dateStr}T${timeStr}`);
    taskData.reminderDate = new Date(`${rdateStr}T${rtimeStr}`);
    
    this.setState({ taskData });

    var contingencies = this.props.transactionData.contingencies;
    this.setState({ contingencies });
    this.getVariables();
    this.getSpecialTasks();
  }

  /**
   * @desc get special task
   */
  getSpecialTasks() {
    this.props.getSpecialTaskAction().then((res) => {
      if (res.status == code.OK) {
        // console.log("this.props.specialTask-311", this.props.specialTask);
        let specialtaskforinterativeEventType = this.props.specialTask;

        let specialtaskforCommunicativeEventTypevariable = this.props.specialTask.filter(
          (obj) => obj.name !== "Appointment"
        );
        // console.log(
        //   "specialtaskforCommunicativeEventType",
        //   specialtaskforCommunicativeEventTypevariable
        // );

        this.setState({
          specialTask: specialtaskforCommunicativeEventTypevariable,
          specialtaskforCommunicativeEventType: specialtaskforCommunicativeEventTypevariable,
          specialtaskforinterativeEventType: this.props.specialTask,
        });
      }
    });
  }

  /**
   * @desc create new task with given data
   * @param {*} values
   */
  addTask(values) {
    var val = values;

    val.transactionId = this.props.transactionData._id;
    //replacing {{ and }} as it comes with mention selection
    val.communicationTo = [
      val.communicationTo
        ? (val.communicationTo[0] + "")
            .replaceAll("{(", "")
            .replaceAll(")}", "")
        : "",
    ];
    //replacing {{ and }} as it comes with mention selection
    val.communicationSubject = [
      val.communicationSubject
        ? (val.communicationSubject[0] + "")
            .replaceAll("{(", "")
            .replaceAll(")}", "")
        : "",
    ];

    if (val.communicationType == "TEXT") {
      if (val.description) {
        val.description = [
          (val.description[0] + "").replace(/\{\(/g, "").replace(/\)\}/g, ""),
        ];
      }

      for (let i = 0; i < val.communicationTo.length; i++) {
        val.communicationTo[i] = val.communicationTo[i]
          .toString()
          .replace(/\-/g, "");
      }
    }

    if (val.eventType === "INTERACTIVE") {
      val.communicationToUserId = getContingencyData(
        this.state.contingencies,
        "First Appointment",
        "assignee"
      );
      // console.log('INTERACTIVE');
      // console.log('val.specialTask',val.specialTask);
      // console.log('this.state.contingencies',this.state.contingencies);
      // if(val.specialTask.includes("Appointment")){
      //   if(val.assignee === "@artist"){
      //     val.communicationToUserId = getContingencyData(
      //       this.state.contingencies,
      //       "Artist",
      //       "assignee"
      //     );
      //   }
      //   else if(val.assignee === "@client"){
      //     val.communicationToUserId = getContingencyData(
      //       this.state.contingencies,
      //       "Client",
      //       "assignee"
      //     );
      //   }
      //   else{
      //     console.log('assignee is other');
      //     val.communicationToUserId = getContingencyData(
      //       this.state.contingencies,
      //       "First Appointment",
      //       "assignee"
      //     );
      //   }
      // }
      // else{
      //   val.communicationToUserId = getContingencyData(
      //     this.state.contingencies,
      //     "First Appointment",
      //     "assignee"
      //   );
      // }
    }

    //change communicationTo string to array
    val.communicationTo = val.communicationTo[0].split(",");

    this.setState({ showLoader: true });

    //Add local timezone offset to request
    var d = new Date();
    val.timeZone = d.getTimezoneOffset().toString();
    var uploadedDocument = [];
    if (this.state.acceptedFiles.length > 0) {
      for (var i = 0; i < this.state.acceptedFiles.length; i++) {
        uploadedDocument.push(this.state.acceptedFiles[i].name);
      }
      val.uploadedDocument = uploadedDocument;
      val.location = "Transaction Docs";
    }

    this.props.createTaskAction(val).then((createRes) => {
      // console.log('createTaskAction res: ', createRes);
      if (createRes.status == code.OK) {
        var formData = new FormData();
        var documents = [];
        var docDetail = {};

        this.setState({ showLoader: true });
        if (this.state.acceptedFiles.length > 0) {
          for (var i = 0; i < this.state.acceptedFiles.length; i++) {
            docDetail = {
              fileName: this.state.acceptedFiles[i].name,
              size: (this.state.acceptedFiles[i].size / (1024 * 1024)).toFixed(
                2
              ),
            };
            documents.push(docDetail);
            formData.append("file", this.state.acceptedFiles[i]);
          }
          var dataToPost = {
            transactionId: this.props.transactionData._id,
            location: "Transaction Docs",
            transactionEventId: createRes.data._id,
            document: documents,
          };
          this.setState({ showLoader: true });
          this.props.addDocAction(dataToPost).then(
            (res) => {
              this.setState({ showLoader: false });
              if (res.status == code.OK) {
                this.setState({ showLoader: true });
                var fileUploadName = "";
                res.data.map((item) => {
                  if (fileUploadName.length > 0) {
                    fileUploadName +=
                      "@@@" + item.document + "###" + item.uploadedFileName;
                  } else {
                    fileUploadName =
                      item.document + "###" + item.uploadedFileName;
                  }
                });
                this.props
                  .uploadDocumentAction(
                    formData,
                    this.props.transactionData._id,
                    undefined,
                    fileUploadName
                  )
                  .then(
                    (res) => {
                      if (res.status == code.OK) {
                        this.setState({ showLoader: false });
                        this.props.documentNotificationAction(
                          this.props.transactionData._id
                        );
                        this.props.onUpdate("update");
                        this.props.onUpdate("update");
                      } else {
                        toastMessage(code.ERROR, res.data);
                      }
                    },
                    (error) => {
                      this.setState({ showLoader: false });
                      this.props.onUpdate("update");
                    }
                  );
              }
            },
            (error) => {
              this.setState({ showLoader: false });
              this.props.onUpdate("update");
            }
          );
        } else {
          this.setState({ showLoader: false });
          this.props.onUpdate("update");
        }
        toastMessage(code.SUCCESS, "Task created successfully");
      } else if (createRes.status === code.CONFLICT) {
        toastMessage(code.ERROR, createRes.data);
        this.props.onUpdate("update");
      }
    });
  }

  handleStartDateChange(date, type, setFieldValue, values) {
    // console.log("date-533", date);
    var taskData = this.state.taskData;
    var dateStr = moment(date).format("YYYY-MM-DD");
    var timeStr = moment(date).format("HH:mm");

    if (type == "time") {
      dateStr = moment(values.eventStartDate).format("YYYY-MM-DD");
    }
    var finalDate = moment(dateStr + " " + timeStr);
    var timeStamp = new Date(finalDate.format("YYYY-MM-DDTHH:mm:ssZ"));
    var formatedDate = moment(timeStamp.getTime()).format(
      "YYYY-MM-DD HH:mm:ss"
    );
    // setFieldValue(
    //   "eventEndDate",
    //   new Date(finalDate.format("YYYY-MM-DD HH:mm"))
    // );
    setFieldValue(
      "eventStartDate",
      moment
        .tz(
          formatedDate,
          "YYYY-MM-DDTHH:mm:ssZ",
          this.props.transactionData.userTimezone
        )
        .utc()
        .format()
    );
    this.setState({
      taskData,
      isDateUpdated: true,
    });

    if (values.specialTask[0] === "Appointment") {
      // console.log("hello guys how are you");
      let starttime = moment
        .tz(
          formatedDate,
          "YYYY-MM-DDTHH:mm:ssZ",
          this.props.transactionData.userTimezone
        )
        .utc()
        .format();
      // console.log("starttime-577", starttime);
      values.eventStartDate = starttime;
      setFieldValue("time", getMinutes(starttime));
      let endTime = new Date(
        new Date(starttime).getTime() + values.duration * 60000
      );
      this.handleEndDateChange(endTime, "time", setFieldValue, values);
    }
  }

  handleEndDateChange(date, type, setFieldValue, values) {
    var taskData = this.state.taskData;
    var dateStr = moment(date).format("YYYY-MM-DD");
    var timeStr = moment(date).format("HH:mm");

    if (type == "time") {
      dateStr = moment(values.eventStartDate).format("YYYY-MM-DD");
      // console.log("dateStr", dateStr);
    }
    var finalDate = moment(dateStr + " " + timeStr);
    var timeStamp = new Date(finalDate.format("YYYY-MM-DDTHH:mm:ssZ"));
    // console.log("timeStamp", timeStamp);
    var formatedDate = moment(timeStamp.getTime()).format(
      "YYYY-MM-DD HH:mm:ss"
    );
    // console.log("formatedDate", formatedDate);
    // console.log('handleEndDateChange formatedDate: ', formatedDate);
    // setFieldValue(
    //   "eventEndDate",
    //   new Date(finalDate.format("YYYY-MM-DD HH:mm"))
    // );
    setFieldValue(
      "eventEndDate",
      moment
        .tz(
          formatedDate,
          "YYYY-MM-DDTHH:mm:ssZ",
          this.props.transactionData.userTimezone
        )
        .utc()
        .format()
    );
    this.setState({
      taskData,
      isDateUpdated: true,
    });
  }

  setDuration(e, setFieldValue, values) {
    let startTime = new Date(values.eventStartDate);
    let duration = parseInt(e);
    // console.log("duration-605", duration);
    let endTime = new Date(startTime.getTime() + duration * 60000);

    // console.log('endTime: ', endTime);
    this.handleEndDateChange(endTime, "time", setFieldValue, values);
    setFieldValue("time", getMinutes(startTime));
    setFieldValue("duration", duration);
  }

  /**
   * @desc set date for reminder - change date format also check selected time and bind it to date
   */
  handleReminerDateChange(date, type, setFieldValue, values) {
    var taskData = this.state.taskData;
    var dateStr = moment(date).format("YYYY-MM-DD");
    var timeStr = moment(date).format("HH:mm");

    if (type == "time") {
      dateStr = moment(values.reminderDate).format("YYYY-MM-DD");
    }
    var finalDate = moment(dateStr + " " + timeStr);
    setFieldValue(
      "reminderDate",
      new Date(finalDate.format("YYYY-MM-DD HH:mm"))
    );
    this.setState({
      taskData,
    });
  }

  /**
   * @desc set selected files to state
   */
  setFiles(files) {
    var acceptedFiles = this.state.acceptedFiles;
    acceptedFiles = _.uniqBy(_.concat(acceptedFiles, files), "name");
    this.setState({
      acceptedFiles,
    });
  }

  /**
   * @desc delete document/file from loaded
   */
  deleteDocument(i) {
    var acceptedFiles = this.state.acceptedFiles;
    acceptedFiles.splice(i, 1);
    this.setState({ acceptedFiles });
  }

  render() {
    var taskData = this.state.taskData;
    var transactionData = this.props.transactionData;
    var tEndData = transactionData.endDate || "";

    //Validation schema
    var addTaskValidationSchema = Yup.object().shape({
      title: Yup.string().required(message.ENTER_TASK_TITLE),
      contingency: Yup.string().required(message.SELECT_CONTINGENCY),
      eventType: Yup.string().required(message.SELECT_TASK_TYPE),
      description: Yup.array()
        .nullable()
        .test("description", message.ENTER_DESCRIPTION, (values) => {
          if (values == "<p></p>\n" || values == "") {
            return false;
          }
          return true;
        }),
    });
    if (this.state.showText) {
      addTaskValidationSchema = Yup.object().shape({
        title: Yup.string().required(message.ENTER_TASK_TITLE),
        contingency: Yup.string().required(message.SELECT_CONTINGENCY),
        communicationTo: Yup.array()
          .nullable()
          .test(
            "email",
            this.state.showText
              ? message.ENTER_VALID_RICIPIENT
              : message.ENTER_TEXT_RECIPIENT,
            (values) => {
              if (values[0] == "") {
                return false;
              }
              return true;
            }
          )
          .test("mail", message.ENTER_VALID_EMAIL, (values) => {
            if (values) {
              var valid = false;
              (values[0] + "").split(/[ ,]+/).forEach((e) => {
                var data = e.replace(/\{\(/g, "").replace(/\)\}/g, "") || "";
                var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
                if (data.trim().indexOf("@") == 0) {
                  valid = true;
                } else {
                  if ((data.trim().match(mailformat) || []).length > 0) {
                    valid = true;
                  } else {
                    valid = false;
                  }
                }
              });
              return valid;
            }
          }),
        communicationSubject: Yup.array()
          .nullable()
          .test("subject", message.ENTER_SUBJECT, (values) => {
            if (this.state.showText == false) {
              return true;
            }
            if (values[0] == "") {
              return false;
            }
            return true;
          }),
      });
    }

    if (!this.state.showText) {
      addTaskValidationSchema = Yup.object().shape({
        title: Yup.string().required(message.ENTER_TASK_TITLE),
        contingency: Yup.string().required(message.SELECT_CONTINGENCY),
        communicationTo: Yup.array()
          .nullable()
          .test("phone", message.ENTER_TEXT_RECIPIENT, (values) => {
            if (values[0] == "") {
              return false;
            }
            return true;
          })
          .test(
            "phone",
            "Please enter valid Phone Number, e.g 999-999-9999.",
            (values) => {
              if (values) {
                var valid = false;
                (values[0] + "")
                  .trim()
                  .split(/[ ,]+/)
                  .forEach((e) => {
                    var data =
                      e.replace(/\{\(/g, "").replace(/\)\}/g, "") || "";
                    var phoneformat = /(?:1?|\+1|\+\s1|\(?)(?:\(?|\s\(|[\.\-\s])\d{3}(?:\)?|\)\s|[\.\-\s])\d{3}[\.\-\s]\d{4}/g;
                    if (data.trim().indexOf("@") == 0) {
                      valid = true;
                    } else {
                      if ((data.trim().match(phoneformat) || []).length > 0) {
                        valid = true;
                      } else {
                        valid = false;
                      }
                    }
                  });
                return valid;
              }
            }
          ),
      });
    }
    if (!this.state.taskType) {
      addTaskValidationSchema = Yup.object().shape({
        title: Yup.string().required(message.ENTER_TASK_TITLE),
        contingency: Yup.string().required(message.SELECT_CONTINGENCY),
        eventType: Yup.string().required(message.SELECT_TASK_TYPE),
        assignee: Yup.string().required(message.SELECT_ASIGNEE),
        description: Yup.array()
          .nullable()
          .test("description", message.ENTER_DESCRIPTION, (values) => {
            if (values == "<p></p>\n" || values == "") {
              return false;
            }
            return true;
          }),
      });
    }

    return (
      <div>
        <div className="progress-div" style={{ display: "none" }}>
          <div className="progress-outer">
            Uploading...
            <ProgressBar animated now={20} />
          </div>
        </div>
        <Formik
          ref={this.myRef}
          validateOnBlur={true}
          initialValues={taskData}
          enableReinitialize={true}
          validationSchema={addTaskValidationSchema}
          onSubmit={(values) => {
            // console.log("values-797", values);
            this.addTask(values);
          }}
        >
          {(formikProps) => {
            const {
              errors,
              values,
              handleBlur,
              setFieldValue,
              touched,
              setErrors,
            } = formikProps;

            return (
              <Form className="add-task-modal" autocomplete="off">
                <Row className="mx-0 task-title-row">
                  <Col className="d-flex align-items-center">
                    <h5 className="font-14 color-blue-4 mb-0">Task Title</h5>
                  </Col>
                  <Col className="col-auto task-schedule">
                    <Row className="align-items-center">
                      <Col className="col-auto px-0 hide-991">
                        <div className="text-right">
                          <Button
                            onClick={() => this.editTask(1)}
                            variant="transparent"
                            className="pl-0"
                          >
                            <Close />
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs="12" className="task-head-name">
                    <Field
                      name="title"
                      type="text"
                      className={"task-add-input form-control field_ucfirst"}
                      placeholder="Write task here"
                      value={values.title}
                      onChange={(e) => {
                        setFieldValue("title", e.target.value);
                      }}
                    />
                    <ErrorMessage
                      name="title"
                      component="div"
                      className="invalid-feedback"
                      style={{ display: "block" }}
                    />
                  </Col>
                </Row>
                <Row className="mx-0 mt-2">
                  <Col xs="12" sm="4">
                    <h5 className="font-14 color-blue-4">Contingency</h5>
                    <div className="c-select">
                      <select
                        name="contingency"
                        id=""
                        className="form-control form-control-xs"
                        value={values.contingency}
                        onChange={(e) => {
                          setFieldValue("contingency", e.target.value);
                          this.getVariables(e.target.value);
                        }}
                      >
                        <option value="">Select</option>
                        {this.state.contingencies.map((e) => {
                          return (
                            <option key={e.name} value={e.name}>
                              {e.name}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    <ErrorMessage
                      name="contingency"
                      component="div"
                      className="invalid-feedback"
                      style={{ display: "block" }}
                    />
                  </Col>
                </Row>
                <Row className="mx-0 mt-2 mb-3">
                  <Col xs="12" sm="4">
                    <h5 className="font-14 color-blue-4">Task Type</h5>
                    <div className="c-select">
                      <select
                        name=""
                        id=""
                        value={values.eventType}
                        className="form-control form-control-xs"
                        onChange={(e) => {
                          setFieldValue("eventType", e.target.value);
                          this.showTaskType(e.target.value);
                        }}
                      >
                        <option value="COMMUNICATION">Communication</option>
                        <option value="INTERACTIVE">Interactive</option>
                      </select>
                    </div>
                    <ErrorMessage
                      name="eventType"
                      component="div"
                      className="invalid-feedback"
                      style={{ display: "block" }}
                    />
                  </Col>
                  {this.state.taskType ? (
                    ""
                  ) : (
                    <Col xs="12" sm="4">
                      <h5 className="font-14 color-blue-4">Special Task</h5>
                      <div className="c-select">
                        <select
                          name="specialTask"
                          component="select"
                          value={values.specialTask}
                          className="form-control form-control-xs"
                          onChange={(e) => {
                            setFieldValue("specialTask", [e.target.value]);
                          }}
                        >
                          <option value="">Select</option>
                          {this.state.specialTask.map((e) => {
                            return (
                              <option key={e.name} value={e.value}>
                                {e.name}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </Col>
                  )}
                </Row>

                <Row
                  className={
                    values.isReminder
                      ? "mx-0 my-3 date-block-wrapper align-items-end"
                      : "mx-0 my-3 date-block-wrapper align-items-center"
                  }
                >
                  <Col className="due-date-block col-auto">
                    <div className="task-date-row mb-3">
                      <div className="icon-wrapper blue-wrapper task-date">
                        <div className="react-bootstrap-daterangepicker-container">
                          <div className="date-label">
                            <span className="form-control-icn">
                              <DateRange />
                            </span>
                            {values.specialTask.includes("Appointment") &&
                            values.contingency.includes("Appointment") &&
                            values.eventType === "INTERACTIVE" ? (
                              <span className="form-control-label">Time:</span>
                            ) : (
                              <span className="form-control-label">Start:</span>
                            )}
                          </div>

                          {values.contingency != undefined &&
                          values.contingency != "" ? (
                            this.state.isDateUpdated ? (
                              <DatePicker
                                selected={
                                  convertTZ(
                                    values.eventStartDate,
                                    this.props.transactionData.userTimezone
                                  ) >
                                  new Date(
                                    this.props.transactionData.startDate || ""
                                  )
                                    ? convertTZ(
                                        values.eventStartDate,
                                        this.props.transactionData.userTimezone
                                      )
                                    : new Date(
                                        this.props.transactionData.startDate ||
                                          ""
                                      )
                                }
                                onChange={(date) =>
                                  this.handleStartDateChange(
                                    date,
                                    "date",
                                    setFieldValue,
                                    values
                                  )
                                }
                                dateFormat="MM-d-yyyy"
                                className="form-control form-control-sm pl-1 date-picker"
                              />
                            ) : (
                              <DatePicker
                                selected={
                                  values.eventStartDate >
                                  new Date(
                                    this.props.transactionData.startDate || ""
                                  )
                                    ? values.eventStartDate
                                    : new Date(
                                        this.props.transactionData.startDate ||
                                          ""
                                      )
                                }
                                onChange={(date) =>
                                  this.handleStartDateChange(
                                    date,
                                    "date",
                                    setFieldValue,
                                    values
                                  )
                                }
                                dateFormat="MM-d-yyyy"
                                className="form-control form-control-sm pl-1 date-picker"
                              />
                            )
                          ) : this.state.isDateUpdated ? (
                            <DatePicker
                              selected={
                                convertTZ(
                                  values.eventStartDate,
                                  this.props.transactionData.userTimezone
                                ) >
                                new Date(
                                  this.props.transactionData.startDate || ""
                                )
                                  ? convertTZ(
                                      values.eventStartDate,
                                      this.props.transactionData.userTimezone
                                    )
                                  : new Date(
                                      this.props.transactionData.startDate || ""
                                    )
                              }
                              onChange={(date) =>
                                this.handleStartDateChange(
                                  date,
                                  "date",
                                  setFieldValue,
                                  values
                                )
                              }
                              dateFormat="MM-d-yyyy"
                              className="form-control form-control-sm pl-1 date-picker"
                            />
                          ) : (
                            <DatePicker
                              selected={
                                values.eventStartDate >
                                new Date(
                                  this.props.transactionData.startDate || ""
                                )
                                  ? values.eventStartDate
                                  : new Date(
                                      this.props.transactionData.startDate || ""
                                    )
                              }
                              onChange={(date) =>
                                this.handleStartDateChange(
                                  date,
                                  "date",
                                  setFieldValue,
                                  values
                                )
                              }
                              dateFormat="MM-d-yyyy"
                              className="form-control form-control-sm pl-1 date-picker"
                            />
                          )}
                          {values.specialTask.includes("Paperwork") &&
                          values.contingency === "Paperwork" ? (
                            ""
                          ) : (
                            <DatePicker
                              selected={convertTZ(
                                values.eventStartDate,
                                this.props.transactionData.userTimezone
                              )}
                              onChange={(date) => {
                                setFieldValue("time", getMinutes(date));
                                this.handleStartDateChange(
                                  date,
                                  "time",
                                  setFieldValue,
                                  values
                                );
                              }}
                              showTimeSelect
                              showTimeSelectOnly
                              // minTime={
                              //   this.state.taskType
                              //     ? new Date(new Date().setHours(8, 0, 0, 0))
                              //     : ""
                              // }
                              // maxTime={
                              //   this.state.taskType
                              //     ? new Date(new Date().setHours(21, 0, 0, 0))
                              //     : ""
                              // }
                              timeIntervals={30}
                              timeCaption="Time"
                              dateFormat="h:mm aa"
                              className="form-control time-task ml-3 form-control-xs pl-1"
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </Col>
                  {values.specialTask.includes("Appointment") &&
                  values.eventType === "INTERACTIVE" ? (
                    <Col className="due-date-block col-auto">
                      <div className="task-date-row mb-3">
                        <div className="icon-wrapper blue-wrapper task-date">
                          <div className="react-bootstrap-daterangepicker-container">
                            <div className="date-label">
                              <span className="form-control-icn">
                                <Schedule />
                              </span>
                              <span className="form-control-label">
                                Duration:
                              </span>
                            </div>
                            <select
                              className="form-control form-control-duration pl-1 date-picker"
                              onChange={(e) =>
                                this.setDuration(
                                  e.target.value,
                                  setFieldValue,
                                  values
                                )
                              }
                            >
                              <option>Select</option>
                              <option value={15}>15 minutes</option>
                              <option value={20}>20 minutes</option>
                              <option value={30}>30 minutes</option>
                              <option value={45}>45 minutes</option>
                              <option value={60}>1 hour</option>
                              <option value={120}>2 hours</option>
                              <option value={180}>3 hours</option>
                              <option value={240}>4 hours</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </Col>
                  ) : values.specialTask.includes("Paperwork") &&
                    values.contingency === "Paperwork" ? (
                    ""
                  ) : (
                    <Col className="due-date-block col-auto">
                      <div className="task-date-row mb-3">
                        <div className="icon-wrapper blue-wrapper task-date">
                          <div className="react-bootstrap-daterangepicker-container">
                            <div className="date-label">
                              <span className="form-control-icn">
                                <DateRange />
                              </span>
                              <span className="form-control-label">End:</span>
                            </div>
                            {values.contingency != undefined &&
                            values.contingency != "" ? (
                              this.state.isDateUpdated ? (
                                <DatePicker
                                  selected={
                                    convertTZ(
                                      values.eventStartDate,
                                      this.props.transactionData.userTimezone
                                    ) >
                                    new Date(
                                      this.props.transactionData.startDate || ""
                                    )
                                      ? convertTZ(
                                          values.eventStartDate,
                                          this.props.transactionData
                                            .userTimezone
                                        )
                                      : new Date(
                                          this.props.transactionData
                                            .startDate || ""
                                        )
                                  }
                                  onChange={(date) =>
                                    this.handleEndDateChange(
                                      date,
                                      "date",
                                      setFieldValue,
                                      values
                                    )
                                  }
                                  dateFormat="MM-d-yyyy"
                                  className="form-control form-control-sm pl-1 date-picker"
                                />
                              ) : (
                                <DatePicker
                                  selected={
                                    values.eventStartDate >
                                    new Date(
                                      this.props.transactionData.startDate || ""
                                    )
                                      ? values.eventStartDate
                                      : new Date(
                                          this.props.transactionData
                                            .startDate || ""
                                        )
                                  }
                                  onChange={(date) =>
                                    this.handleEndDateChange(
                                      date,
                                      "date",
                                      setFieldValue,
                                      values
                                    )
                                  }
                                  dateFormat="MM-d-yyyy"
                                  className="form-control form-control-sm pl-1 date-picker"
                                />
                              )
                            ) : this.state.isDateUpdated ? (
                              <DatePicker
                                selected={
                                  convertTZ(
                                    values.eventStartDate,
                                    this.props.transactionData.userTimezone
                                  ) >
                                  new Date(
                                    this.props.transactionData.startDate || ""
                                  )
                                    ? convertTZ(
                                        values.eventStartDate,
                                        this.props.transactionData.userTimezone
                                      )
                                    : new Date(
                                        this.props.transactionData.startDate ||
                                          ""
                                      )
                                }
                                onChange={(date) =>
                                  this.handleEndDateChange(
                                    date,
                                    "date",
                                    setFieldValue,
                                    values
                                  )
                                }
                                dateFormat="MM-d-yyyy"
                                className="form-control form-control-sm pl-1 date-picker"
                              />
                            ) : (
                              <DatePicker
                                selected={
                                  values.eventStartDate >
                                  new Date(
                                    this.props.transactionData.startDate || ""
                                  )
                                    ? values.eventStartDate
                                    : new Date(
                                        this.props.transactionData.startDate ||
                                          ""
                                      )
                                }
                                onChange={(date) =>
                                  this.handleEndDateChange(
                                    date,
                                    "date",
                                    setFieldValue,
                                    values
                                  )
                                }
                                dateFormat="MM-d-yyyy"
                                className="form-control form-control-sm pl-1 date-picker"
                              />
                            )}

                            <DatePicker
                              selected={convertTZ(
                                values.eventEndDate,
                                this.props.transactionData.userTimezone
                              )}
                              onChange={(date) => {
                                //setFieldValue("time", getMinutes(date));
                                this.handleEndDateChange(
                                  date,
                                  "time",
                                  setFieldValue,
                                  values
                                );
                              }}
                              showTimeSelect
                              showTimeSelectOnly
                              // minTime={
                              //   this.state.taskType
                              //     ? new Date(new Date().setHours(8, 0, 0, 0))
                              //     : ""
                              // }
                              // maxTime={
                              //   this.state.taskType
                              //     ? new Date(new Date().setHours(21, 0, 0, 0))
                              //     : ""
                              // }
                              timeIntervals={30}
                              timeCaption="Time"
                              dateFormat="h:mm aa"
                              className="form-control time-task ml-3 form-control-xs pl-1"
                            />
                          </div>
                        </div>
                      </div>
                    </Col>
                  )}
                </Row>

                {this.state.taskType ? (
                  // task communication
                  <div style={{ backgroundColor: "#f8f8f8" }}>
                    <Row className="mx-0 bg-blue-5 py-2 mb-2">
                      <Col xs="12">
                        <h5 className="font-14 color-blue-4 mb-1">
                          Communication Type
                        </h5>
                        <div className="form-group mb-0">
                          <div className="custom-control custom-radio custom-radio-sm custom-control-inline">
                            <input
                              name="communicationType"
                              type="radio"
                              className="custom-control-input"
                              id="check1"
                              value="EMAIL"
                              onChange={(e) => {
                                this.showText(e.target.value);
                                this.clearCommunication(
                                  setFieldValue,
                                  setErrors
                                );
                                setFieldValue("communicationType", "EMAIL");
                                setErrors({});
                              }}
                              checked={
                                values.communicationType === "EMAIL"
                                  ? "checked"
                                  : ""
                              }
                            />

                            <label
                              className="custom-control-label color-grey-1"
                              htmlFor="check1"
                            >
                              Email
                            </label>
                          </div>
                          <div className="custom-control custom-radio custom-radio-sm custom-control-inline">
                            <input
                              name="communicationType"
                              type="radio"
                              className="custom-control-input"
                              id="check2"
                              value="TEXT"
                              onChange={(e) => {
                                this.showText(e.target.value);
                                this.clearCommunication(
                                  setFieldValue,
                                  setErrors
                                );
                                setFieldValue("communicationType", "TEXT");
                                setErrors({});
                              }}
                              checked={
                                values.communicationType === "TEXT"
                                  ? "checked"
                                  : ""
                              }
                            />
                            <label
                              className="custom-control-label color-grey-1"
                              htmlFor="check2"
                            >
                              Text
                            </label>
                          </div>
                        </div>
                        <ErrorMessage
                          name="communicationType"
                          component="div"
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        />
                      </Col>
                    </Row>
                    <Row className="mx-0 mail-row">
                      <Col className="col-auto pr-0">
                        <h5 className="font-14 color-blue-4 mb-0">To</h5>
                      </Col>
                      <Col className="mail-row-field mail-row-field-regular">
                        <MentionsInput
                          singleLine
                          name="communicationTo[0]"
                          type="text"
                          value={
                            values.communicationTo
                              ? values.communicationTo[0]
                              : ""
                          }
                          className={
                            "mail-row-mension " +
                            (errors.communicationTo &&
                            errors.communicationTo[0] &&
                            touched.communicationTo &&
                            touched.communicationTo[0]
                              ? " is-invalid"
                              : "")
                          }
                          onChange={(e) => {
                            setFieldValue("communicationTo", [e.target.value]);
                          }}
                          style={defaultStyle}
                        >
                          <Mention
                            trigger="@"
                            appendSpaceOnAdd={false}
                            data={
                              this.state.showText
                                ? this.state.emailRefVar
                                : this.state.textRefVar
                            }
                            markup="{(__id__)}"
                          />
                        </MentionsInput>
                        <ErrorMessage
                          name="communicationTo"
                          component="div"
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        />
                      </Col>
                    </Row>
                    {this.state.showText ? (
                      <div>
                        <hr className="mt-2 mb-2" />
                        <Row className="mx-0 mail-row">
                          <Col className="col-auto pr-0">
                            <h5 className="font-14 color-blue-4 mb-0">
                              Subject
                            </h5>
                          </Col>
                          <Col className="mail-row-field-big">
                            <MentionsInput
                              singleLine
                              name="communicationSubject[0]"
                              type="text"
                              value={
                                values.communicationSubject
                                  ? values.communicationSubject[0]
                                  : ""
                              }
                              className={
                                "mail-row-mension " +
                                (errors.communicationSubject &&
                                errors.communicationSubject[0] &&
                                touched.communicationSubject &&
                                touched.communicationSubject[0]
                                  ? " is-invalid"
                                  : "")
                              }
                              onChange={(e) => {
                                setFieldValue("communicationSubject", [
                                  e.target.value,
                                ]);
                              }}
                              style={defaultStyle}
                            >
                              <Mention
                                trigger="@"
                                appendSpaceOnAdd={false}
                                data={this.state.AllRefVar}
                                markup="{(__id__)}"
                              />
                            </MentionsInput>
                            <ErrorMessage
                              name="communicationSubject"
                              component="div"
                              className="invalid-feedback"
                              style={{ display: "block" }}
                            />
                          </Col>
                        </Row>
                      </div>
                    ) : (
                      ""
                    )}
                    <hr className="mt-2" />

                    <Row className="mx-0 align-items-center pb-3">
                      {this.state.showText ? (
                        <Col xs="12">
                          <div className="editor-main">
                            <Editor
                              wrapperClassName="demo-wrapper"
                              editorClassName="demo-editor"
                              mention={{
                                separator: " ",
                                trigger: "@",
                                suggestions: this.state.AllRefVarForEditor,
                              }}
                              handlePastedText={() => false}
                              toolbar={{
                                options: [
                                  "inline",
                                  "list",
                                  "link",
                                  "blockType",
                                ],
                                inline: {
                                  inDropdown: false,
                                  options: ["bold", "italic"],
                                },
                                list: {
                                  inDropdown: true,
                                  options: ["unordered", "ordered"],
                                },
                                link: { inDropdown: false, options: ["link"] },
                                blockType: {
                                  inDropdown: false,
                                  options: ["Blockquote"],
                                },
                              }}
                              name="description[0]"
                              editorState={this.state.emailTextValForEditor}
                              onEditorStateChange={(e) => {
                                var ediData = draftToHtml(
                                  convertToRaw(e.getCurrentContent())
                                );
                                var tempDom = $("<output>").append(
                                  $.parseHTML(ediData)
                                );

                                let finalval = tempDom.html();
                                setFieldValue("description", [finalval]);

                                this.setState({ emailTextValForEditor: e });
                              }}
                              hashtag={{}}
                            />
                          </div>
                        </Col>
                      ) : (
                        <Col xs="12">
                          <MentionsInput
                            multiLine
                            name="description[0]"
                            type="textarea"
                            value={
                              values.description ? values.description[0] : ""
                            }
                            className={
                              "font-14 " +
                              (errors.description &&
                              errors.description[0] &&
                              touched.description &&
                              touched.description[0]
                                ? " is-invalid"
                                : "")
                            }
                            onChange={(e) => {
                              setFieldValue("description", [e.target.value]);
                            }}
                            style={defaultStyle}
                          >
                            <Mention
                              trigger="@"
                              appendSpaceOnAdd={true}
                              data={this.state.AllRefVar}
                              markup="{(__id__)}"
                            />
                          </MentionsInput>
                        </Col>
                      )}
                      <ErrorMessage
                        name="description"
                        component="div"
                        className="invalid-feedback"
                        style={{ display: "block" }}
                      />
                    </Row>
                  </div>
                ) : (
                  // task Interactive
                  <div>
                    <Row className="mx-0 mb-2 bg-blue-5 py-2">
                      <Col>
                        <div className="custom-control custom-checkbox custom-control-inline">
                          <input
                            name="docRequired"
                            type="checkbox"
                            className="custom-control-input"
                            id="docRequired"
                            checked={values.document}
                            onChange={(e) => {
                              setFieldValue("document", e.target.checked);
                            }}
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="docRequired"
                          >
                            Document upload required
                          </label>
                        </div>
                      </Col>
                    </Row>

                    <Row className="mx-0 mail-row assign-var-row">
                      <Col className="col-auto pr-0">
                        <h5 className="font-14 color-blue-4 mb-0">Assign to</h5>
                      </Col>
                      <Col className="assign-var-select">
                        <ReactSelect
                          onBlur={handleBlur}
                          fullWidth
                          onChange={(e) => {
                            setFieldValue("assignee", e.value);
                          }}
                          value={{
                            label: values.assignee,
                            value: values.assignee,
                          }}
                          className="react-select-wrapper react-select-multi"
                          name="assignee"
                          options={this.state.assigneeOptions}
                        />
                        <ErrorMessage
                          name="assignee"
                          component="div"
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        />
                      </Col>
                    </Row>

                    <hr className="mt-2 mb-2" />
                    <Row className="mx-0">
                      <Col>
                        <h5 className="font-14 color-blue-4">Detail</h5>
                        <div className="editor-main">
                          <Editor
                            wrapperClassName="demo-wrapper"
                            editorClassName="demo-editor"
                            mention={{
                              separator: " ",
                              trigger: "@",
                              suggestions: this.state.AllRefVarForEditor,
                            }}
                            handlePastedText={() => false}
                            toolbar={{
                              options: ["inline", "list", "link", "blockType"],
                              inline: {
                                inDropdown: false,
                                options: ["bold", "italic"],
                              },
                              list: {
                                inDropdown: true,
                                options: ["unordered", "ordered"],
                              },
                              link: { inDropdown: false, options: ["link"] },
                              blockType: {
                                inDropdown: false,
                                options: ["Blockquote"],
                              },
                            }}
                            name="description[0]"
                            editorState={this.state.detailsValForEditor}
                            onEditorStateChange={(e) => {
                              var ediData = draftToHtml(
                                convertToRaw(e.getCurrentContent())
                              );
                              var tempDom = $("<output>").append(
                                $.parseHTML(ediData)
                              );
                              //removing link from selected variables from mention
                              $.map(tempDom.find("a.wysiwyg-mention"), function(
                                elem,
                                index
                              ) {
                                let newVal = $(elem).html();
                                elem.replaceWith(newVal);
                              });

                              let finalval = tempDom.html();
                              setFieldValue("description", [finalval]);

                              this.setState({ detailsValForEditor: e });
                            }}
                            hashtag={{}}
                          />
                        </div>
                        <ErrorMessage
                          name="description"
                          component="div"
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        />
                      </Col>
                    </Row>
                  </div>
                )}

                <div
                  style={{
                    backgroundColor: "#f8f8f8",
                    padding: "0px 15px 15px 15px",
                  }}
                >
                  <Dropzone
                    maxSize={100000000}
                    accept={[
                      "image/*",
                      "application/pdf",
                      "application/msword",
                      ".docx",
                      ".xml",
                      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                    ]}
                    onDrop={(acceptedFiles) => {
                      this.setFiles(acceptedFiles);
                    }}
                  >
                    {({ getRootProps, getInputProps }) => (
                      <section>
                        <div
                          className="dropzone-transaction drop-task"
                          {...getRootProps()}
                        >
                          <input {...getInputProps()} />
                          <AttachFile />
                          <p>
                            <strong>Attach or Drop document here</strong>
                          </p>
                        </div>
                      </section>
                    )}
                  </Dropzone>
                </div>

                {this.state.acceptedFiles.map((file, i) => {
                  return (
                    <Row className="mx-0 align-items-center mt-3">
                      <Col className="col-auto font-14 font-500">
                        {file.name}
                      </Col>
                      <Button
                        variant="transparent"
                        className="comments-delete"
                        onClick={() => this.deleteDocument(i)}
                      >
                        <DeleteOutline />
                      </Button>
                    </Row>
                  );
                })}

                <Row className="mx-0 py-3">
                  <Col xs="6">
                    <Button type="submit" size="sm" className="btn-blue w-140">
                      {"Add Task"}
                    </Button>
                  </Col>
                </Row>
              </Form>
            );
          }}
        </Formik>

        {/* Dependency Modal */}
        <Modal
          show={this.state.DependencyModal}
          onHide={() => this.DependencyModal()}
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
          className="modal-med1 dependency-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-custom-modal-styling-title">
              Set Dependency
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <SetDependency />
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    taskData: state.reducer.taskData,
    variablesRefs: state.reducer.variablesRefs,
    specialTask: state.reducer.specialTask,
  };
};

export default connect(
  mapStateToProps,
  {
    getVarriableRefAction,
    createTaskAction,
    uploadDocumentAction,
    addDocAction,
    updateDocAction,
    listDocAction,
    getSpecialTaskAction,
    documentNotificationAction,
  }
)(TaskAdd);
